var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade pt-popin-mobile-details",
      attrs: {
        id: _vm.id,
        "aria-labelledby": _vm.id,
        tabindex: "-1",
        role: "dialog",
        "aria-hidden": "true",
        "data-ob1-component": "Popin",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content pb-0 px-1 px-md-2" }, [
          _vm.cartOfferDetails
            ? _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body px-0" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-12 px-2 px-md-3 px-lg-5" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm.showBanner(_vm.cartOfferDetails.banner)
                            ? _c("strong", {
                                directives: [
                                  {
                                    name: "msh-html",
                                    rawName: "v-msh-html",
                                    value: _vm.cartOfferDetails.banner,
                                    expression: "cartOfferDetails.banner",
                                  },
                                ],
                                staticClass: "ob1-tag ob1-tag-primary mb-1",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h2", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                                        " +
                                _vm._s(_vm.cartOfferDetails.offerType) +
                                " " +
                                _vm._s(_vm.cartOfferDetails.name) +
                                "\n                                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.cartOfferDetails.offerType
                            ? _c(
                                "p",
                                {
                                  staticClass: "pt-xl-1 py-0 mb-0 fw-bold",
                                  attrs: { "aria-hidden": "true" },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(_vm.cartOfferDetails.offerType) +
                                      "\n                                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass: "py-0 mb-0",
                              class: _vm.cartOfferDetails.offerType
                                ? "h1"
                                : "h4",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._v(
                                "\n                                        " +
                                  _vm._s(_vm.cartOfferDetails.name) +
                                  "\n                                    "
                              ),
                            ]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-4 mt-3" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm.cartOfferDetails.detailAttributes &&
                          _vm.cartOfferDetails.detailAttributes.length > 0
                            ? _c(
                                "div",
                                {
                                  staticClass: "accordion",
                                  attrs: {
                                    itemscope: "",
                                    itemtype: "https://schema.org/FAQPage",
                                  },
                                },
                                _vm._l(
                                  _vm.cartOfferDetails.detailAttributes,
                                  function (detailAttribute, attributeIndex) {
                                    return _c(
                                      "div",
                                      {
                                        key: `${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                        staticClass: "card multi",
                                        attrs: {
                                          itemscope: "",
                                          itemprop: "mainEntity",
                                          itemtype:
                                            "https://schema.org/Question",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "card-header" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "collapsed",
                                                attrs: {
                                                  id: `faqQuestion-${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                                  "data-bs-toggle": "collapse",
                                                  "data-bs-target": `#faqAnswer-${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                                  "aria-controls": `faqAnswer-${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                                  "aria-expanded": "false",
                                                  type: "button",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "accordion-card-title",
                                                  },
                                                  [
                                                    _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "accordion-title mb-0",
                                                        attrs: {
                                                          itemprop: "name",
                                                        },
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              detailAttribute.titleAttribute
                                                            )
                                                          ),
                                                        ]),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c("p", {
                                                      staticClass:
                                                        "accordion-icon mb-0",
                                                      attrs: {
                                                        "aria-hidden": "true",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "collapse",
                                            attrs: {
                                              id: `faqAnswer-${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                              "aria-labelledby": `faqQuestion-${_vm.cartOfferDetails.idSeo}-${attributeIndex}`,
                                              role: "region",
                                              itemscope: "",
                                              itemprop: "acceptedAnswer",
                                              itemtype:
                                                "https://schema.org/Answer",
                                            },
                                          },
                                          [
                                            _c("div", {
                                              staticClass:
                                                "accordion-card-body standard",
                                              attrs: { itemprop: "text" },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  detailAttribute.textAttribute
                                                ),
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c(
                                "div",
                                { staticClass: "text-center text-muted py-4" },
                                [
                                  _c("p", [
                                    _vm._v(
                                      "Aucun détail disponible pour cette offre."
                                    ),
                                  ]),
                                ]
                              ),
                        ]),
                      ]),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "sticky-bottom py-2 bg-white modal-footer d-flex justify-content-center",
                  },
                  [
                    _vm.closeButtonLabel
                      ? _c("ob1-boutons", {
                          attrs: {
                            "is-button": true,
                            "is-primary": true,
                            "is-wide": false,
                            label: _vm.closeButtonLabel,
                            "data-bs-dismiss": "modal",
                          },
                          on: { "ob1-boutons-click": _vm.onClose },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "modal-header" }, [
      _c(
        "button",
        {
          staticClass: "btn-close pt-2 pt-md-0",
          staticStyle: { display: "block !important" },
          attrs: {
            type: "button",
            "data-bs-dismiss": "modal",
            "aria-label": "Fermer",
          },
        },
        [
          _c("span", {
            staticClass: "icon icon-delete",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn-close ob1-link-arrow back",
          staticStyle: { display: "none !important" },
          attrs: { type: "button", "data-bs-dismiss": "modal" },
        },
        [_vm._v("\n                        Fermer\n                    ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }